import { Controller } from '@hotwired/stimulus'
import 'select2'
import 'select2/dist/js/i18n/de'

// Connects to data-controller="client-picker"
export default class extends Controller {
  connect() {
    this.initSelect2(this.element)
  }

  initSelect2(element) {
    $(element).select2({
      theme: 'bootstrap4',
      minimumInputLength: 3,
      tags: true,
      ajax: {
        url: '/api/internal/search/clients',
        dataType: 'json',
        data: ({ term }) => ({ query: term }),
        delay: 500,
        processResults: (clients) => {
          const results = clients.map((client) => (
            Object.assign({
              id: client.customer_name,
              text: client.customer_name
            }, client)
          ))
          return { results }
        },
      },
      templateResult: (state) => {
        if (!state.id) {
          return state.text;
        }
        const { text, phone, location, address2, email } = state
        return $(
          '<div>' +
          text +
          (phone ? ('<div class="text-sm font-weight-lighter">' + phone + '</div>') : '') +
          (email ? ('<div class="text-sm font-weight-lighter">' + email + '</div>') : '') +
          (location ? ('<div class="text-sm font-weight-lighter">' + location.name + '</div>') : '') +
          (address2 ? ('<div class="text-sm font-weight-lighter">' + address2 + '</div>') : '') +
          '</div>'
        )
      }
    }).on('select2:select', (e) => {
      const { phone, email, location, address2 } = e.params.data

      this.dispatch('pick', {
        detail: { phone, email, location, address2 }
      })
    })
  }

  disconnect() {
    $(this.element).select2('destroy')
  }
}
